import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { toast } from '@/shared/lib/toast';
interface ShareData {
  url: string;
  title?: string;
}

export function useShare() {
  const t = useTranslations('render.options');

  const share = useCallback(
    async (data: ShareData): Promise<void> => {
      if (navigator.share) {
        try {
          await navigator.share(data);
          return;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            return;
          }
        }
      }

      await navigator.clipboard.writeText(data.url);
      toast.success(t('linkCopied'));
    },
    [t]
  );

  return { share };
}
